module.controller('sampleReceiveCtrl', ['$controller', '$timeout', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService',
		'securityService', 'urlSampleDetail', sampleReceiveCtrlFn ]);

function sampleReceiveCtrlFn($controller, $timeout, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil, securityService, urlSampleDetail) {

	// Hereda el controlador
	$controller('sampleHomeDetailBaseCtrl', {
		$timeout : $timeout,
		$scope : $scope,
		$rootScope : $rootScope,
		$state : $state,
		planSamplingService : planSamplingService,
		alertService : alertService,
		dateUtilService : dateUtil,
		securityService : securityService,
		urlSampleDetail : urlSampleDetail
	});
}